import Vue from "vue";
import Router from "vue-router";
import store from "@/store";

Vue.use(Router);

const routes = [
  {
    path: "/",
    component: () => import("@/views/Index"),
    children: [
      {
        name: "Authentication",
        path: "auth",
        component: () => import("@/views/auth/Index")
      },
      {
        name: "Verification",
        path: "verify",
        component: () => import("@/views/auth/Verify")
      },
      {
        name: "Reset",
        path: "reset",
        component: () => import("@/views/auth/Reset")
      },
      {
        path: "/",
        component: () => import("@/views/website/Index"),
        children: [
          {
            name: "Overview",
            path: "/",
            component: () => import("@/views/website/Overview")
          },
          {
            name: "Developer",
            path: "developer",
            component: () => import("@/views/website/Developer")
          },
          {
            name: "Features",
            path: "features",
            component: () => import("@/views/website/Features")
          },
          {
            name: "Pricing",
            path: "pricing",
            component: () => import("@/views/website/Pricing")
          },
          {
            name: "Contact",
            path: "contact",
            component: () => import("@/views/website/Contact")
          }
        ]
      },
      {
        path: "/portal",
        name: "Portal",
        component: () => import("@/views/portal/Index"),
        children: [
          {
            name: "Details",
            path: "details",
            component: () => import("@/views/portal/Details")
          },
          {
            path: "admin",
            component: () => import("@/views/portal/admin/Index"),
            children: [
              {
                name: "Admin Package",
                path: "package",
                component: () => import("@/views/portal/admin/Package")
              },
              {
                name: "Admin Package Service",
                path: "service",
                component: () => import("@/views/portal/admin/Service")
              },
              {
                name: "Admin Users",
                path: "user",
                component: () => import("@/views/portal/admin/User")
              },
              {
                name: "Admin List",
                path: "admin",
                component: () => import("@/views/portal/admin/Admin")
              },
              {
                name: "Admin Logs",
                path: "log",
                component: () => import("@/views/portal/admin/Log")
              },
              {
                name: "Admin Top Up Records",
                path: "topup",
                component: () => import("@/views/portal/admin/Topup")
              },
            ]
          },
          {
            path: "user",
            component: () => import("@/views/portal/user/Index"),
            children: [
              {
                name: "User Package",
                path: "package",
                component: () => import("@/views/portal/user/Package")
              },
              {
                name: "User Purchase",
                path: "purchase",
                component: () => import("@/views/portal/user/Purchase")
              },
              {
                name: "User Service",
                path: "service",
                component: () => import("@/views/portal/user/Service")
              },
              {
                name: "OCR",
                path: "ocr",
                component: () => import("@/views/portal/user/Ocr")
              },
              {
                name: "FR",
                path: "fr",
                component: () => import("@/views/portal/user/Fr")
              },
              {
                name: "Landmark",
                path: "landmark",
                component: () => import("@/views/portal/user/Landmark")
              },
              {
                name: "Liveness",
                path: "liveness",
                component: () => import("@/views/portal/user/Liveness")
              },
              {
                name: "Upload & Sign",
                path: "upload",
                component: () => import("@/views/portal/user/Upload")
              },
              {
                name: "User List",
                path: "user",
                component: () => import("@/views/portal/user/User")
              },
              {
                name: "User Log",
                path: "log",
                component: () => import("@/views/portal/user/Log")
              },
              {
                name: "User Top Up Records",
                path: "topup",
                component: () => import("@/views/portal/user/Topup")
              },
            ]
          },
        ]
      }
    ]
  }
];

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  var isAuthenticated = store.getters.isLoggedIn;
  var isParent = store.getters.isParent;

  if (to.path.includes("portal") && !isAuthenticated) next({
    path: "auth", query: {
      mode: 'login'
    }
  });
  else if (to.name == "Admin Users" && !isParent) next({
    name: "Admin Package"
  });
  else next();
});

export default router;